"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47654,6148],{

/***/ 469100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ListTile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? "#f5f5f5" : "#fff"};
    padding: 0.6rem;
    cursor: ${props.onClick ? "pointer" : ""};
    &:hover {
      background-color: ${props.type !== "search-suggestion" && "#f5f5f5"};
    }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    leading,
    title,
    trailing,
    numberOfLine = 1,
    onClick,
    onMouseEnter,
    type,
    selected = false
  } = _b, props = __objRest(_b, [
    "leading",
    "title",
    "trailing",
    "numberOfLine",
    "onClick",
    "onMouseEnter",
    "type",
    "selected"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({
    ref,
    selected,
    onMouseEnter
  }, props), {
    onClick,
    type
  }), leading, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    numberOfLine
  }, title), trailing);
});
ListTile.displayName = "ListTile";




/***/ }),

/***/ 865237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCol = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ col }) => {
  if (!col) {
    return {
      flex: "1 0 0%",
      minWidth: 0
    };
  }
  return {
    flex: "0 0 auto",
    width: `${col / 12 * 100}%`,
    paddingRight: "0.5rem",
    paddingLeft: "0.5rem"
  };
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Col = (_a) => {
  var _b = _a, {
    children,
    col
  } = _b, props = __objRest(_b, [
    "children",
    "col"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadValues({
    col
  }, props), children);
};




/***/ }),

/***/ 995667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledRow = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ noGutters }) => `
  display: flex;
  flex-wrap: wrap;
  ${noGutters ? "" : `
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  `}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Row = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRow, __spreadValues({}, props), children);
};




/***/ }),

/***/ 708966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ButtonChevron; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(650983);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTransform = (props) => {
  let style = "";
  switch (props.direction) {
    case "right":
      style = "transform: rotate(90deg)";
      break;
    case "down":
      style = "transform: rotate(180deg)";
      break;
    case "left":
      style = "transform: rotate(-90deg)";
      break;
  }
  return style;
};
const StyledIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  display: flex;
`;
const Text = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
`;
const ButtonChevron = (_a) => {
  var _b = _a, {
    children,
    direction,
    showArrow = true
  } = _b, props = __objRest(_b, [
    "children",
    "direction",
    "showArrow"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, children), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    direction,
    name: "chevron-up",
    size: 12
  }));
};




/***/ }),

/***/ 797864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? "padding: .5rem;" : ""}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const CardHeader = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardBody = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const CardFooter = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, withPadding } = _b, props = __objRest(_b, ["children", "header", "footer", "withPadding"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    ref,
    withPadding
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 387974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ BuildPCPicker; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcSummary/BuildPcSummary.es.js + 1 modules
var BuildPcSummary_es = __webpack_require__(924780);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(528938);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../packages/utils/dist/object.es.js
var object_es = __webpack_require__(535820);
// EXTERNAL MODULE: ./containers/BuildPc/BuildPcMobileItem.tsx
var BuildPcMobileItem = __webpack_require__(481689);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./containers/BuildPc/BuildPcMobileTabs.tsx
var BuildPcMobileTabs = __webpack_require__(704251);
// EXTERNAL MODULE: ./contexts/BuildPCContextV2.tsx
var BuildPCContextV2 = __webpack_require__(39486);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/usePos365StoreCode.ts
var usePos365StoreCode = __webpack_require__(268055);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./modules/search-page/shared/helpers.ts
var helpers = __webpack_require__(774608);
// EXTERNAL MODULE: ./hooks/useBuildPcProducts.ts
var useBuildPcProducts = __webpack_require__(566783);
// EXTERNAL MODULE: ./helpers/buildpc.ts
var buildpc = __webpack_require__(329040);
// EXTERNAL MODULE: ./constants/buildpc.ts
var constants_buildpc = __webpack_require__(360339);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./components/mobile/organisms/BuildPC/BuildPCFilterMobile.tsx
var BuildPCFilterMobile = __webpack_require__(344520);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Pagination/Pagination.es.js
var Pagination_es = __webpack_require__(628054);
;// CONCATENATED MODULE: ./components/mobile/organisms/BuildPC/BuildPcModalComponent.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding: 0.5rem 0.75rem;\n  position: sticky;\n  top: 0px;\n  z-index: 1040;\n  height: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1rem;\n  font-weight: 700;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  padding: 0 16px;\n  bottom: 0px;\n  background-color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  > :first-child {\n    width: 100%;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  height: calc(\n    100% - 40px - 40px - 50px\n  ); // minus the height of title container, filters & pagination\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  height: calc(\n    100% - 40px - 40px - 50px\n  ); // minus the height of title container, filters & pagination\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














const ProductList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(39460)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductList), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const ProductGrid = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(39460)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductGrid), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const NotFound = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(39460)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.NoProductsFound), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const BuildPcModalComponent = (props)=>{
    const { collectionSlug , keyword , currentPage , categoryName , onPageChange , onClose ,  } = props;
    const { 0: priceFilterValue , 1: setPriceFilterValue  } = (0,react.useState)();
    const { 0: productCardType , 1: setProductCardType  } = (0,react.useState)("grid");
    const { pos365StoreCode  } = (0,usePos365StoreCode/* usePos365StoreCode */.c)();
    const { showCollectionPageTitle , contactLink  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: activeOptions , 1: setActiveOptions  } = (0,react.useState)([]);
    const { 0: activeSortOption , 1: setActiveSortOption  } = (0,react.useState)();
    const [sort, order] = activeSortOption ? (0,helpers/* extractSortQuery */.To)(activeSortOption.optionCode) : [
        undefined,
        undefined
    ];
    const { filter , loading: filterLoading  } = (0,useBuildPcProducts/* useBuildPcProducts */.R)({
        slug: collectionSlug,
        returnFilterable: [
            "FILTER_TYPE_ATTRIBUTE",
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_CLEARANCE", 
        ],
        pageSize: 1
    }, onClose, categoryName);
    const filters = !!filter ? (0,discovery/* convertDiscoveryFilter */.px)(filter) : [];
    const priceFilter = (0,helpers/* cookFilterPrice */.kr)(filter === null || filter === void 0 ? void 0 : filter.priceLte, filter === null || filter === void 0 ? void 0 : filter.priceGte);
    const onSortOptionSelected = (sortOption)=>{
        if (sortOption.optionCode === (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode)) {
            setActiveSortOption(undefined);
        } else {
            setActiveSortOption(sortOption);
        }
    };
    const onSubmit = (activeFilters, filterPriceValue)=>{
        setActiveOptions(activeFilters);
        setPriceFilterValue(filterPriceValue);
    };
    const onClearFilters = ()=>onSubmit([], {
            gte: priceFilter.min,
            lte: priceFilter.max
        });
    const { products , pagination , loading: isLoading ,  } = (0,useBuildPcProducts/* useBuildPcProducts */.R)({
        slug: collectionSlug,
        query: keyword,
        sorting: (0,discovery/* convertToPayloadSorting */.EN)(sort, order),
        filter: (0,dist_index_es.cleanObject)(_objectSpreadProps(_objectSpread({}, (0,buildpc/* convertFilter */.pu)(activeOptions)), {
            priceGte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.gte,
            priceLte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.lte
        })),
        pageSize: constants_buildpc/* BUILD_PC_MODAL_PAGE_SIZE */.aJ,
        page: currentPage
    }, onClose, categoryName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!showCollectionPageTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageTitleContainer, {
                justify: "start",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        style: {
                            maxWidth: "90%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle, {
                            children: (0,i18n.t)("Chọn linh kiện")
                        })
                    }),
                    (pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                            color: "textSecondary",
                            weight: "regular",
                            style: {
                                fontSize: "0.75rem",
                                lineHeight: "0.75rem"
                            },
                            children: (0,i18n.t)("({{quantity}} sản phẩm)", {
                                quantity: pagination === null || pagination === void 0 ? void 0 : pagination.totalItems
                            })
                        })
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCFilterMobile/* BuildPCFilterMobile */.Q, {
                loading: filterLoading,
                onClickLayout: ()=>setProductCardType(productCardType === "grid" ? "list" : "grid"),
                layoutType: pos365StoreCode ? "list" : productCardType,
                filters: filters,
                filterPrice: _objectSpreadProps(_objectSpread({}, priceFilter), {
                    value: priceFilterValue || constants_buildpc/* DEFAULT_PRICE_FILTER */.DT
                }),
                activeSortOption: activeSortOption,
                activeOptions: activeOptions,
                onSortOptionSelected: onSortOptionSelected,
                onSubmit: onSubmit,
                onClearFilters: onClearFilters
            }),
            pos365StoreCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductList, {
                products: products,
                contactLink: contactLink,
                itemsPerPage: !!pagination ? Math.ceil((pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) / (pagination === null || pagination === void 0 ? void 0 : pagination.totalPages)) : search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductGrid, {
                type: productCardType,
                products: products,
                contactLink: contactLink,
                productsPerRow: 2,
                itemsPerPage: !!pagination ? Math.ceil((pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) / (pagination === null || pagination === void 0 ? void 0 : pagination.totalPages)) : search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9
            }),
            !isLoading && (products === null || products === void 0 ? void 0 : products.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {
                show: true
            }),
            !!pagination ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                justify: "center",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPagination, {
                    height: "50px",
                    pageNeighbor: 1,
                    totalRecords: pagination === null || pagination === void 0 ? void 0 : pagination.totalItems,
                    currentPage: currentPage,
                    onPageChange: onPageChange
                })
            }) : null
        ]
    });
};
const PageTitleContainer = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});
const PageTitle = emotion_styled_browser_esm["default"].h1(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const StyledFooter = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject2());
const StyledPagination = (0,emotion_styled_browser_esm["default"])(Pagination_es/* Pagination */.t)(_templateObject3());
const StyledProductGrid = (0,emotion_styled_browser_esm["default"])(ProductGrid)(_templateObject4());
const StyledProductList = (0,emotion_styled_browser_esm["default"])(ProductList)(_templateObject5());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SearchOutlined.es.js
var SearchOutlined_es = __webpack_require__(877936);
;// CONCATENATED MODULE: ./components/mobile/organisms/BuildPC/BuildPCModal.tsx
function BuildPCModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BuildPCModal_templateObject() {
    const data = BuildPCModal_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: auto;\n  .bottom-sheet-header {\n    padding: 8px;\n    height: ",
        ";\n  }\n"
    ]);
    BuildPCModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const BOTTOM_SHEET_HEADER_HEIGHT = "57px";
const BuildPCModalMobile = (props)=>{
    const { collectionSlug , categoryName , visible , onClose  } = props;
    const { 0: keyword , 1: setKeyword  } = (0,react.useState)("");
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    const onClickSearch = (keyword)=>{
        setKeyword(keyword);
        setCurrentPage(1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomSheet, {
        zIndex: 1060,
        show: visible,
        closeBottomSheet: onClose,
        forceRender: true,
        closeIconPosition: "right",
        contentHeight: "calc(100% - ".concat(BOTTOM_SHEET_HEADER_HEIGHT, ")"),
        showBottomSheetHeader: true,
        filterNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
            placeholder: (0,i18n.t)("T\xecm kiếm"),
            width: "80%",
            marginLeft: "s20",
            onKeyUp: (e)=>{
                const keyword = e.target.value;
                if (e.keyCode === 13) {
                    onClickSearch(keyword);
                }
            },
            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined_es/* SearchOutlined */.l, {
                size: 20
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModalComponent, {
            collectionSlug: collectionSlug,
            categoryName: categoryName,
            keyword: keyword,
            currentPage: currentPage,
            onPageChange: (page)=>setCurrentPage(page),
            onClose: onClose
        })
    });
};
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)(BuildPCModal_templateObject(), BOTTOM_SHEET_HEADER_HEIGHT);

// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var log_dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./components/mobile/organisms/BuildPC/BuildPCPicker.tsx
function BuildPCPicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BuildPCPicker_templateObject() {
    const data = BuildPCPicker_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    BuildPCPicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuildPCPicker_templateObject1() {
    const data = BuildPCPicker_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  width: 100%;\n"
    ]);
    BuildPCPicker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














const BuildPCPicker = ()=>{
    var ref;
    const router = (0,next_router.useRouter)();
    const { buildPCData , buildPCDetailProducts , changeActiveConfig , increaseHardwareQuantity , decreaseHardwareQuantity , setHardwareQuantity , estimatedAmount , removeHardware , updateCurrentConfig ,  } = (0,BuildPCContextV2/* useBuildPCV2 */.s)();
    const { buildPcMapping  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onAddMultipleItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    const { 0: selectedCategory , 1: setSelectedCategory  } = (0,react.useState)("");
    const buildPcMappingKeys = (0,react.useMemo)(()=>{
        return !!buildPcMapping && !(0,object_es/* isEmptyObject */.Q)(buildPcMapping) ? Object.keys(buildPcMapping) : [];
    }, [
        buildPcMapping
    ]);
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(buildPCData.currentConfig);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                var ref;
                const key = configKeys[i];
                const productData = buildPCDetailProducts.products.find((product)=>{
                    var ref;
                    return product.sku === ((ref = buildPCData.currentConfig[key]) === null || ref === void 0 ? void 0 : ref.sku);
                });
                const quantity = (ref = buildPCData.currentConfig[key]) === null || ref === void 0 ? void 0 : ref.quantity;
                if (!!productData && !(0,object_es/* isEmptyObject */.Q)(productData) && !!quantity) products.push({
                    sku: productData.sku,
                    quantity,
                    promotionId: !!productData.selectPromotionId ? productData.selectPromotionId : undefined
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            log_dist_index_es/* logger.log */.k.log(error);
        }
    };
    if (!buildPcMapping || (0,object_es/* isEmptyObject */.Q)(buildPcMapping)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                padding: "0 1rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                    marginTop: "s16",
                    justify: "space-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcMobileTabs/* default */.Z, {
                        lsActiveTab: buildPCData.activeIndex,
                        onClickTab: (index)=>{
                            changeActiveConfig(index);
                            (0,helper_es/* trackCustomEvent */.I)("changeBuildPCConfig", {
                                action: "click",
                                category: "buildpc",
                                value: index + 1
                            });
                        },
                        onResetConfig: ()=>updateCurrentConfig({})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    marginTop: "s16",
                    children: [
                        buildPcMappingKeys.map((buildPcMappingKey, index)=>{
                            const selectedHardware = buildPCData.currentConfig[buildPcMappingKey];
                            const productData = buildPCDetailProducts.products.find((product)=>{
                                return product.sku === (selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.sku);
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBuildPcItem, {
                                title: buildPcMapping[buildPcMappingKey].name,
                                icon: buildPcMapping[buildPcMappingKey].icon,
                                onIncrease: ()=>{
                                    increaseHardwareQuantity(buildPcMappingKey);
                                },
                                onDecrease: ()=>{
                                    // remove hardware from config when quantity < 1
                                    (selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.quantity) === 1 ? removeHardware(buildPcMappingKey) : decreaseHardwareQuantity(buildPcMappingKey);
                                },
                                setQuantity: (value)=>{
                                    setHardwareQuantity(buildPcMappingKey, value);
                                },
                                product: !!productData && !(0,object_es/* isEmptyObject */.Q)(productData) ? productData : undefined,
                                actionText: productData ? (0,i18n.t)("Sửa") : (0,i18n.t)("Chọn"),
                                onClick: ()=>setSelectedCategory(buildPcMappingKey),
                                quantity: selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.quantity,
                                showDeleteButton: true,
                                onDelete: ()=>removeHardware(buildPcMappingKey)
                            }, "".concat(index, "-").concat(buildPcMappingKey));
                        }),
                        !!selectedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCModalMobile, {
                            visible: !!selectedCategory,
                            collectionSlug: ((ref = buildPcMapping[selectedCategory]) === null || ref === void 0 ? void 0 : ref.slug) || "",
                            categoryName: selectedCategory,
                            onClose: ()=>setSelectedCategory("")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                    marginTop: "s8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBuildPcSummary, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcSummary_es/* BuildPcSummary */.b, {
                                total: estimatedAmount,
                                selectedCount: Object.keys(buildPCData.currentConfig).length,
                                onAddToCart: onAddConfigurationToCart,
                                onBuy: ()=>{
                                    onAddConfigurationToCart().then(()=>router.push("/cart"));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
                                marginTop: "s16",
                                padding: "s16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                        variant: "primary",
                                        block: true,
                                        onClick: ()=>window.print(),
                                        marginBottom: "s16",
                                        children: (0,i18n.t)("Tải file PDF cấu h\xecnh")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                        targetType: "_blank",
                                        targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                            variant: "primary",
                                            block: true,
                                            children: (0,i18n.t)("Nhận tư vấn từ chuy\xean gia")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const StyledBuildPcItem = (0,emotion_styled_browser_esm["default"])(BuildPcMobileItem/* BuildPcMobileItem */.g)(BuildPCPicker_templateObject());
const StyledBuildPcSummary = emotion_styled_browser_esm["default"].div(BuildPCPicker_templateObject1());


/***/ }),

/***/ 968887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BuildPCPickerDesktopSlot": function() { return /* reexport */ BuildPCPickerDesktopSlot; },
  "BuildPCPickerMobileSlot": function() { return /* reexport */ BuildPCPickerMobileSlot; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcTabs/BuildPcTabs.es.js
var BuildPcTabs_es = __webpack_require__(562194);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcSummary/BuildPcSummary.es.js + 1 modules
var BuildPcSummary_es = __webpack_require__(924780);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(528938);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcItem/BuildPcItem.es.js
var BuildPcItem_es = __webpack_require__(123579);
// EXTERNAL MODULE: ./contexts/BuildPCContextV2.tsx
var BuildPCContextV2 = __webpack_require__(39486);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ../../packages/utils/dist/object.es.js
var object_es = __webpack_require__(535820);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./components/desktop/organisms/BuildPC/BuildPcModal.tsx
var BuildPcModal = __webpack_require__(468418);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./components/desktop/organisms/BuildPC/BuildPCPicker.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 80px;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












const BuildPCPicker = ()=>{
    var ref;
    const router = (0,next_router.useRouter)();
    const { buildPCData , buildPCDetailProducts , changeActiveConfig , increaseHardwareQuantity , decreaseHardwareQuantity , setHardwareQuantity , estimatedAmount , removeHardware , updateCurrentConfig ,  } = (0,BuildPCContextV2/* useBuildPCV2 */.s)();
    const { buildPcMapping  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { onAddMultipleItems  } = (0,CartContextV2/* useCartV2 */.T6)();
    const { 0: selectedCategory , 1: setSelectedCategory  } = (0,react.useState)("");
    const buildPcMappingKeys = (0,react.useMemo)(()=>{
        return !!buildPcMapping && !(0,object_es/* isEmptyObject */.Q)(buildPcMapping) ? Object.keys(buildPcMapping) : [];
    }, [
        buildPcMapping
    ]);
    if ((0,object_es/* isEmptyObject */.Q)(buildPcMapping) || !buildPcMapping) {
        return null;
    }
    const onAddConfigurationToCart = async ()=>{
        try {
            const configKeys = Object.keys(buildPCData.currentConfig);
            const products = [];
            for(let i = 0; i < configKeys.length; i += 1){
                var ref;
                const key = configKeys[i];
                const productData = buildPCDetailProducts.products.find((product)=>{
                    var ref;
                    return product.sku === ((ref = buildPCData.currentConfig[key]) === null || ref === void 0 ? void 0 : ref.sku);
                });
                const quantity = (ref = buildPCData.currentConfig[key]) === null || ref === void 0 ? void 0 : ref.quantity;
                if (!!productData && !(0,object_es/* isEmptyObject */.Q)(productData) && !!quantity) products.push({
                    sku: productData.sku,
                    quantity,
                    promotionId: !!productData.selectPromotionId ? productData.selectPromotionId : undefined
                });
            }
            await onAddMultipleItems(products);
        } catch (error) {
            index_es/* logger.log */.k.log(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                marginTop: "s16",
                justify: "space-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                    span: 8.5,
                    paddingLeft: "s8",
                    paddingRight: "s8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcTabs_es/* BuildPcTabs */.N, {
                        lsActiveTab: buildPCData.activeIndex,
                        onClickTab: (index)=>{
                            changeActiveConfig(index);
                            (0,helper_es/* trackCustomEvent */.I)("changeBuildPCConfig", {
                                action: "click",
                                category: "buildpc",
                                value: index + 1
                            });
                        },
                        onResetConfig: ()=>updateCurrentConfig({})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                marginTop: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: 8.5,
                        paddingLeft: "s8",
                        paddingRight: "s8",
                        children: buildPcMappingKeys.map((buildPcMappingKey, index)=>{
                            const selectedHardware = buildPCData.currentConfig[buildPcMappingKey];
                            const productData = buildPCDetailProducts.products.find((product)=>{
                                return product.sku === (selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.sku);
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBuildPcItem, {
                                title: buildPcMapping[buildPcMappingKey].name,
                                icon: buildPcMapping[buildPcMappingKey].icon,
                                onIncrease: ()=>{
                                    increaseHardwareQuantity(buildPcMappingKey);
                                },
                                onDecrease: ()=>{
                                    // remove hardware from config when quantity < 1
                                    (selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.quantity) === 1 ? removeHardware(buildPcMappingKey) : decreaseHardwareQuantity(buildPcMappingKey);
                                },
                                setQuantity: (value)=>{
                                    setHardwareQuantity(buildPcMappingKey, value);
                                },
                                product: !!productData && !(0,object_es/* isEmptyObject */.Q)(productData) ? productData : undefined,
                                actionText: productData ? (0,i18n.t)("Sửa") : (0,i18n.t)("Chọn"),
                                onClick: ()=>{
                                    setSelectedCategory(buildPcMappingKey);
                                },
                                quantity: selectedHardware === null || selectedHardware === void 0 ? void 0 : selectedHardware.quantity,
                                showDeleteButton: true,
                                onDelete: ()=>removeHardware(buildPcMappingKey)
                            }, "".concat(index, "-").concat(buildPcMappingKey));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: 3.5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBuildPcSummary, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcSummary_es/* BuildPcSummary */.b, {
                                    total: estimatedAmount,
                                    selectedCount: Object.keys(buildPCData.currentConfig).length,
                                    onAddToCart: onAddConfigurationToCart,
                                    onBuy: ()=>{
                                        onAddConfigurationToCart().then(()=>router.push("/cart"));
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                    marginTop: "s16",
                                    padding: "s16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                                        targetType: "_blank",
                                        targetPath: "https://www.messenger.com/t/phongvuvietnam",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                                            variant: "primary",
                                            block: true,
                                            children: (0,i18n.t)("Nhận tư vấn từ chuy\xean gia")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !!selectedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModal/* BuildPcModal */.j, {
                visible: !!selectedCategory,
                onClose: ()=>setSelectedCategory(""),
                categoryName: selectedCategory,
                collectionSlug: ((ref = buildPcMapping[selectedCategory]) === null || ref === void 0 ? void 0 : ref.slug) || ""
            })
        ]
    });
};
const StyledBuildPcItem = (0,emotion_styled_browser_esm["default"])(BuildPcItem_es/* BuildPcItem */.y)(_templateObject());
const StyledBuildPcSummary = emotion_styled_browser_esm["default"].div(_templateObject1());

;// CONCATENATED MODULE: ./modules/page-builder/slots/BuildPC/BuildPCPickerDesktopSlot.tsx



const BuildPCPickerDesktopSlot = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCPicker, {});
};

// EXTERNAL MODULE: ./components/mobile/organisms/BuildPC/BuildPCPicker.tsx + 2 modules
var BuildPC_BuildPCPicker = __webpack_require__(387974);
;// CONCATENATED MODULE: ./modules/page-builder/slots/BuildPC/BuildPCPickerMobileSlot.tsx



const BuildPCPickerMobileSlot = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPC_BuildPCPicker/* BuildPCPicker */.f, {});
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/BuildPC/index.ts




/***/ }),

/***/ 506148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(347714);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(896687);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ })

}]);